import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { IncomingEcomEInvoiceUnMatchedHistoryContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_incoming_ecom_einvoice_unmatched_history_container.model';
import { ApiResponseModel, ApiVisa } from '../shared';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class IncomingEcomEInvoiceUnMatchedHistoryService extends BaseApiTemplateService<IncomingEcomEInvoiceUnMatchedHistoryContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/incoming-einvoice-unmatched-history/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/incoming-einvoice-unmatched-history/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/incoming-einvoice-unmatched-history/backoffice-ep'
    this.httpClient = http;
  }

  pushToUnmatchedHistory(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "e-invoice/incoming-einvoice-unmatched-history/custom/multi/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  pushBackToQueue(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "e-invoice/incoming-einvoice-unmatched-history/push-back/multi/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
